export default __webpack_public_path__ + "static/media/customerStepImg_EN.e7960723.png";